import classNames from 'classnames'
import { ReactNode, ChangeEvent } from 'react'

import ContainerHomGradientBorder from './Containers/ContainerHomGradientBorder'
import SVGIcon from './Icons/svgs/SVGIcon'
import ChevronDownIcon from './Icons/svgs/ChevronDownIcon'

interface Props {
  children: ReactNode
  error?: string | undefined
  multiple?: boolean
  name: string
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void
  value: string
  className?: string
  isSelected?: boolean
}

export function SelectBoxHomGradient({
  children,
  multiple,
  name,
  onChange,
  value,
  className = '',
  error = '',
  isSelected,
}: Props): React.ReactElement {
  const selectClassNames = classNames(
    'w-full p-4 pr-10',
    'font-semibold truncate bg-transparent',
    'appearance-none cursor-pointer focus:outline-none',
    className,
  )
  return (
    <ContainerHomGradientBorder
      error={error}
      innerClassName={`relative ${isSelected ? 'bg-green-lime' : 'bg-white'}`}
      outerClassName="w-full"
    >
      <select className={selectClassNames} multiple={multiple} name={name} onChange={onChange} value={value}>
        {children}
      </select>
      <div className="absolute top-1/2 right-4 w-5 h-5 transform -translate-y-1/2 pointer-events-none">
        <span className="h-full flex items-center justify-center rounded-full bg-blue-iris">
          <SVGIcon icon={ChevronDownIcon} pathClassName="text-white" size={10} />
        </span>
      </div>
    </ContainerHomGradientBorder>
  )
}
